import { render, staticRenderFns } from "./GameChannel.vue?vue&type=template&id=cfadd9ac&"
import script from "./GameChannel.vue?vue&type=script&lang=js&"
export * from "./GameChannel.vue?vue&type=script&lang=js&"
import style0 from "./GameChannel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports